import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "hidden lg:block overflow-x-auto max-h-[600px] overflow-y-auto" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = { class: "bg-gradient-to-r from-slate-50 to-slate-100 sticky top-0 z-10" }
const _hoisted_5 = { class: "flex items-center gap-2" }
const _hoisted_6 = ["d"]
const _hoisted_7 = { class: "bg-white divide-y divide-slate-100" }
const _hoisted_8 = { class: "px-6 py-5 whitespace-nowrap" }
const _hoisted_9 = { class: "font-semibold text-slate-900" }
const _hoisted_10 = { class: "px-6 py-5 font-semibold text-slate-900" }
const _hoisted_11 = { class: "px-6 py-5 text-sm text-slate-600" }
const _hoisted_12 = { class: "px-6 py-5 text-sm text-slate-600" }
const _hoisted_13 = { class: "px-6 py-5 text-sm text-slate-600" }
const _hoisted_14 = { class: "px-6 py-5" }
const _hoisted_15 = { class: "px-6 py-5 text-sm text-slate-600" }
const _hoisted_16 = { class: "px-6 py-5 whitespace-nowrap" }
const _hoisted_17 = { class: "flex gap-2" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "mt-5 lg:hidden space-y-4 max-h-[600px] overflow-y-auto px-4" }
const _hoisted_21 = { class: "bg-gradient-to-r from-slate-50 to-slate-100 px-4 py-3 border-b border-slate-200" }
const _hoisted_22 = { class: "flex items-start justify-between gap-3" }
const _hoisted_23 = { class: "flex-1 min-w-0 flex items-center gap-3" }
const _hoisted_24 = { class: "flex-shrink-0 w-8 h-8 flex items-center justify-center bg-slate-200 rounded-full font-bold text-slate-700 text-sm" }
const _hoisted_25 = { class: "flex-1 min-w-0" }
const _hoisted_26 = { class: "font-bold text-slate-900 text-base truncate" }
const _hoisted_27 = { class: "text-xs text-slate-500 mt-1 flex items-center gap-1" }
const _hoisted_28 = { class: "px-4 py-3 space-y-3" }
const _hoisted_29 = { class: "text-sm text-slate-700 mt-1 line-clamp-3" }
const _hoisted_30 = { class: "text-sm text-slate-700 mt-1 line-clamp-3" }
const _hoisted_31 = { class: "text-xs font-semibold text-slate-500 uppercase tracking-wide" }
const _hoisted_32 = { class: "text-sm text-slate-700 mt-1 line-clamp-3" }
const _hoisted_33 = { class: "flex items-center justify-between py-2 px-3 bg-slate-50 rounded-lg" }
const _hoisted_34 = { class: "flex gap-2 pt-2" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 0,
  class: "fixed bg-black bg-opacity-50 backdrop-blur-sm inset-0 z-50 overflow-y-auto",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_38 = { class: "flex min-h-full items-center justify-center p-4 text-center sm:p-0" }
const _hoisted_39 = { class: "relative transform overflow-hidden rounded-2xl bg-white text-left shadow-xl transition-all w-full max-w-lg" }
const _hoisted_40 = { class: "px-6 py-4" }
const _hoisted_41 = { class: "text-sm text-slate-600 text-center mb-4" }
const _hoisted_42 = { class: "font-semibold text-slate-900" }
const _hoisted_43 = { class: "bg-slate-50 px-6 py-4 flex flex-col-reverse sm:flex-row gap-3" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { key: 0 }
const _hoisted_46 = {
  key: 1,
  class: "flex items-center justify-center gap-2"
}

import { ref, watch } from "vue";
import AdminToggleSwitch from "@/share/components/admin/AdminToggleSwitch.vue";
import type { Proveedore } from "../../interfaces/proveedorInterfaces/Proveedor.interface";

interface Props {
  proveedores: Proveedore[];
  sortField: string | null;
  sortDirection: "asc" | "desc";
    isDelete?: boolean;
  // Nuevas props para calcular el índice correcto
  currentPage?: number;
  pageSize?: number;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ProveedorTable',
  props: {
    proveedores: {},
    sortField: {},
    sortDirection: {},
    isDelete: { type: Boolean },
    currentPage: { default: 1 },
    pageSize: { default: 10 }
  },
  emits: ["sort", "toggleVisibility", "editProveedor", "deleteProveedor"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
// Calcular el índice base según la página actual
const getGlobalIndex = (localIndex: number) => {
  return (props.currentPage - 1) * props.pageSize + localIndex + 1;
};

const showDeleteModal = ref(false);
const proveedorToDelete = ref<{ id: string; nombre: string } | null>(null);
const isDeleting = ref(false);

const getSortIcon = (field: string) => {
  if (props.sortField !== field) {
    return "M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4";
  }
  return props.sortDirection === "asc"
    ? "M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"
    : "M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4";
};

const formatDate = (dateString: string) =>
  new Date(dateString).toLocaleDateString("es-ES", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

const getVisibilidadText = (isVisible: number) =>
  isVisible === 1 ? "Visible" : "Oculto";

const toggleVisibility = async (proveedorId: string) => {
  const proveedor = props.proveedores.find((p) => p.id === proveedorId);
  if (!proveedor) return;
  proveedor.isVisible = proveedor.isVisible === 1 ? 0 : 1;
  await new Promise((resolve) => setTimeout(resolve, 150));
  emit("toggleVisibility", proveedorId);
};

const openDeleteModal = (proveedorId: string, nombre: string) => {
  proveedorToDelete.value = { id: proveedorId, nombre };
  showDeleteModal.value = true;
};

const closeDeleteModal = () => {
  showDeleteModal.value = false;
  proveedorToDelete.value = null;
};

const confirmDelete = () => {
if (!proveedorToDelete.value || isDeleting.value) return;
  isDeleting.value = true;
  emit("deleteProveedor", proveedorToDelete.value.id);
};

const editProveedor = (proveedorId: string) => {
  emit("editProveedor", proveedorId);
};
watch(
  () => props.isDelete,
  (newVal) => {
    if (newVal) {
      showDeleteModal.value = false;
      proveedorToDelete.value = null;
      isDeleting.value = false;
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("thead", _hoisted_4, [
          _createElementVNode("tr", null, [
            _cache[2] || (_cache[2] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xl font-bold text-slate-800 uppercase tracking-wider" }, " # ", -1)),
            _createElementVNode("th", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('sort', 'nombreProveedor'))),
              class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase cursor-pointer hover:bg-slate-200 transition-colors group"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _cache[1] || (_cache[1] = _createElementVNode("span", null, "Proveedor", -1)),
                (_openBlock(), _createElementBlock("svg", {
                  class: _normalizeClass(["w-4 h-4 text-slate-400 group-hover:text-slate-600", {
                    'text-blue-600': props.sortField === 'nombreProveedor',
                  }]),
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: getSortIcon('nombreProveedor')
                  }, null, 8, _hoisted_6)
                ], 2))
              ])
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase" }, " N_Documento ", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase" }, " T_Documento ", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase" }, " Teléfono ", -1)),
            _cache[6] || (_cache[6] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase" }, " Visibilidad ", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase" }, " Creado ", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase" }, " Acciones ", -1))
          ])
        ]),
        _createElementVNode("tbody", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.proveedores, (proveedor, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: proveedor.id,
              class: "hover:bg-slate-50 transition-all duration-200 group"
            }, [
              _createElementVNode("td", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(getGlobalIndex(index)), 1)
              ]),
              _createElementVNode("td", _hoisted_10, _toDisplayString(proveedor.nombreProveedor), 1),
              _createElementVNode("td", _hoisted_11, _toDisplayString(proveedor.documentoProveedor), 1),
              _createElementVNode("td", _hoisted_12, _toDisplayString(proveedor.tipoDocumento?.nombre), 1),
              _createElementVNode("td", _hoisted_13, _toDisplayString(proveedor.telefonoProveedor || "—"), 1),
              _createElementVNode("td", _hoisted_14, [
                _createVNode(AdminToggleSwitch, {
                  "model-value": proveedor.isVisible === 1,
                  color: "red",
                  "show-state-text": "",
                  "label-position": "left",
                  "switch-id": 'prov-vis-desktop-' + proveedor.id,
                  onToggle: ($event: any) => (toggleVisibility(proveedor.id))
                }, null, 8, ["model-value", "switch-id", "onToggle"])
              ]),
              _createElementVNode("td", _hoisted_15, _toDisplayString(formatDate(proveedor.createdAt)), 1),
              _createElementVNode("td", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (editProveedor(proveedor.id)),
                    class: "p-2 text-blue-600 hover:bg-blue-50 rounded-lg",
                    title: "Editar"
                  }, [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("svg", {
                      class: "w-5 h-5",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414\n                         a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                      })
                    ], -1)
                  ]))], 8, _hoisted_18),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (
                    openDeleteModal(proveedor.id, proveedor.nombreProveedor)
                  ),
                    class: "p-2 text-red-600 hover:bg-red-50 rounded-lg",
                    title: "Eliminar"
                  }, [...(_cache[10] || (_cache[10] = [
                    _createElementVNode("svg", {
                      class: "w-5 h-5",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862\n                         a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4\n                         a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      })
                    ], -1)
                  ]))], 8, _hoisted_19)
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.proveedores, (proveedor, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: proveedor.id,
          class: "bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden hover:shadow-md transition-shadow"
        }, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("span", _hoisted_24, _toDisplayString(getGlobalIndex(index)), 1),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("h3", _hoisted_26, _toDisplayString(proveedor.nombreProveedor), 1),
                  _createElementVNode("p", _hoisted_27, [
                    _cache[11] || (_cache[11] = _createElementVNode("svg", {
                      class: "w-3 h-3",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      })
                    ], -1)),
                    _createTextVNode(" " + _toDisplayString(formatDate(proveedor.createdAt)), 1)
                  ])
                ]),
                _createVNode(AdminToggleSwitch, {
                  "model-value": proveedor.isVisible === 1,
                  color: "red",
                  "switch-id": 'prov-vis-mobile-' + proveedor.id,
                  onToggle: ($event: any) => (toggleVisibility(proveedor.id))
                }, null, 8, ["model-value", "switch-id", "onToggle"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", null, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { class: "text-xs font-semibold text-slate-500 uppercase tracking-wide" }, "Descripción", -1)),
              _createElementVNode("p", _hoisted_29, _toDisplayString(proveedor.descripcionProveedor || "Sin descripción"), 1)
            ]),
            _createElementVNode("div", null, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { class: "text-xs font-semibold text-slate-500 uppercase tracking-wide" }, "Teléfono", -1)),
              _createElementVNode("p", _hoisted_30, _toDisplayString(proveedor.telefonoProveedor || "Sin descripción"), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_31, _toDisplayString(proveedor.tipoDocumento.nombre), 1),
              _createElementVNode("p", _hoisted_32, _toDisplayString(proveedor.documentoProveedor || "Sin descripción"), 1)
            ]),
            _createElementVNode("div", _hoisted_33, [
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-xs font-semibold text-slate-500 uppercase" }, "Estado", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium", 
                proveedor.isVisible === 1
                  ? 'bg-red-100 text-red-700'
                  : 'bg-gray-100 text-gray-700'
              ])
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["w-1.5 h-1.5 rounded-full", 
                  proveedor.isVisible === 1 ? 'bg-red-600' : 'bg-slate-500'
                ])
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(getVisibilidadText(proveedor.isVisible)), 1)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("button", {
                onClick: ($event: any) => (editProveedor(proveedor.id)),
                class: "flex-1 flex items-center justify-center gap-2 px-4 py-2.5 bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 transition-colors font-medium text-sm"
              }, [...(_cache[15] || (_cache[15] = [
                _createElementVNode("svg", {
                  class: "w-4 h-4",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  })
                ], -1),
                _createTextVNode(" Editar ", -1)
              ]))], 8, _hoisted_35),
              _createElementVNode("button", {
                onClick: ($event: any) => (openDeleteModal(proveedor.id, proveedor.nombreProveedor)),
                class: "flex-1 flex items-center justify-center gap-2 px-4 py-2.5 bg-red-50 text-red-700 rounded-lg hover:bg-red-100 transition-colors font-medium text-sm"
              }, [...(_cache[16] || (_cache[16] = [
                _createElementVNode("svg", {
                  class: "w-4 h-4",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  })
                ], -1),
                _createTextVNode(" Eliminar ", -1)
              ]))], 8, _hoisted_36)
            ])
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (showDeleteModal.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _createElementVNode("div", {
                class: "fixed inset-0 transition-opacity",
                onClick: closeDeleteModal
              }),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _cache[21] || (_cache[21] = _createElementVNode("div", { class: "bg-gradient-to-br from-red-50 to-rose-50 px-6 pt-6 pb-4" }, [
                    _createElementVNode("div", { class: "flex items-center justify-center w-16 h-16 mx-auto bg-red-100 rounded-full" }, [
                      _createElementVNode("svg", {
                        class: "w-8 h-8 text-red-600",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        })
                      ])
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_40, [
                    _cache[18] || (_cache[18] = _createElementVNode("h3", {
                      class: "text-xl font-bold text-slate-900 text-center mb-2",
                      id: "modal-title"
                    }, " ¿Eliminar Proveedor? ", -1)),
                    _createElementVNode("p", _hoisted_41, [
                      _cache[17] || (_cache[17] = _createTextVNode(" Estás a punto de eliminar el proveedor ", -1)),
                      _createElementVNode("span", _hoisted_42, " \"" + _toDisplayString(proveedorToDelete.value?.nombre) + "\" ", 1)
                    ]),
                    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "bg-amber-50 border-l-4 border-amber-400 p-4 rounded" }, [
                      _createElementVNode("div", { class: "flex gap-3" }, [
                        _createElementVNode("svg", {
                          class: "w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          })
                        ]),
                        _createElementVNode("p", { class: "text-sm text-amber-800" }, " Esta acción no se puede deshacer. Los proveedores asociados a esta categoría podrían verse afectados. ")
                      ])
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: closeDeleteModal,
                      class: "flex-1 px-4 py-2.5 bg-white border-2 border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-slate-500 focus:ring-offset-2"
                    }, " Cancelar "),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: confirmDelete,
                      disabled: isDeleting.value,
                      class: _normalizeClass(["flex-1 px-4 py-2.5 rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 shadow-sm", {
                  'bg-red-600 text-white hover:bg-red-700': !isDeleting.value,
                  'bg-red-400 text-white opacity-70 cursor-not-allowed':
                    isDeleting.value,
                }])
                    }, [
                      (!isDeleting.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_45, "Sí, eliminar"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_46, [...(_cache[20] || (_cache[20] = [
                            _createElementVNode("svg", {
                              class: "animate-spin w-4 h-4 text-white",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("circle", {
                                class: "opacity-25",
                                cx: "12",
                                cy: "12",
                                r: "10",
                                stroke: "currentColor",
                                "stroke-width": "4"
                              }),
                              _createElementVNode("path", {
                                class: "opacity-75",
                                fill: "currentColor",
                                d: "M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l3 3-3 3v-4a8 8 0 01-8-8z"
                              })
                            ], -1),
                            _createTextVNode(" Eliminando... ", -1)
                          ]))]))
                    ], 10, _hoisted_44)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})